import React from 'react'

export function Pen() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2867 3.61501C15.4788 3.42115 15.7073 3.26708 15.959 3.16163C16.2107 3.05619 16.4807 3.00143 16.7537 3.0005C17.0266 2.99957 17.297 3.05249 17.5494 3.15622C17.8018 3.25995 18.0313 3.41246 18.2247 3.60501L20.3917 5.76801C21.1917 6.56501 21.2017 7.85301 20.4177 8.66401L17.8547 11.307L8.94073 20.088C8.60673 20.418 8.17073 20.624 7.70473 20.673L4.71773 20.992C4.49014 21.0168 4.25988 20.9908 4.04352 20.916C3.82715 20.8412 3.63004 20.7194 3.46635 20.5594C3.30267 20.3993 3.17647 20.205 3.09682 19.9903C3.01718 19.7757 2.98607 19.5461 3.00573 19.318L3.26573 16.281C3.30873 15.796 3.52173 15.34 3.86873 14.995L12.7247 6.20201L15.2877 3.61501H15.2867ZM13.4567 8.39001L5.32973 16.459L5.12173 18.872L7.48373 18.619L15.6487 10.576L13.4567 8.39001ZM17.1067 9.10901L14.9187 6.92601L16.7597 5.06601L18.9277 7.22801L17.1057 9.10801L17.1067 9.10901Z"
        fill="#292E3D"
      />
    </svg>
  )
}
